export enum MapActionTypes {
  FILTER_ALARM = "@@Map/FILTER_ALARM",
  SELECT_DATE = "@@Map/SELECT_DATE",
  RERENDER = "@@Map/RERENDER",
  RESET_STATE = "@@Map/RESET_STATE",
  DISPLAY_GRAPH = "@@Map/DISPLAY_GRAPH",
  GENERATE_MAP_UUID = "@@Map/GENERATE_MAP_UUID",
  GOOGLE_MAPS = "@@Map/GOOGLE_MAPS"
}
